import Script, { ScriptProps } from 'next/script';

export const SpiffScript: React.FC<ScriptProps> = (props) => (
    <Script
        strategy="lazyOnload"
        type="text/javascript"
        {...props}
        id="SpiffAPI"
        src="https://assets.us.spiffcommerce.com/api.js"
    />
);
